export const postiesMenuData = [
  {
    name: "Why Posties?",
    urlAlias: "/posties/parents#why-posties",
  },
  {
    name: "News",
    urlAlias: "/posties/parents#news",
  },
  {
    name: "Subscribe",
    urlAlias: "/posties/parents#subscribe",
  },
  {
    name: "Redeem",
    urlAlias: "/posties/redeem",
  },
];
